<div class="row">
    <div class="col-md-12">
        <ax-panel title="Doenças Ativas">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridAtivas
                    [dataSource]="registrosDoencasAtivas"

                    [enableVirtualization]='true'  height='200' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 
                    
                    [toolbar]="toolbarDoencasAtivasItens"

                    class="grid-clickable"
                    [selectionSettings]="{ enableToggle: false }"

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    (toolbarClick)='toobarClick($event);'
                    >
                    <e-columns>
                        <e-column field='id' width='50' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='cid10Texto' [headerText]="'CID10'" [visible]="true"></e-column>
                        <e-column field='dataDiagnostico' width="100" [headerText]="'Data Diagnóstico'" [type]="'date'" 
                        [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='dataAtendimento' width="100" [headerText]="'Última Modificação'" [type]="'date'" 
                        [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='drt' [headerText]="'DRT'" type="boolean" [displayAsCheckBox]="true"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
    <div class="col-md-12">
        <ax-panel title="Doenças Inativas">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridInativas
                    [dataSource]="registrosDoencasInativas"

                    [enableVirtualization]='true'  height='200' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 

                    [toolbar]="toolbarDoencasInativasItens"

                    class="grid-clickable"
                    [selectionSettings]="{ enableToggle: false }"

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    (toolbarClick)='toobarClick($event);'
                    >
                    <e-columns>
                        <e-column field='id' width='50' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='cid10Texto' [headerText]="'CID10'" [visible]="true"></e-column>
                        <e-column field='dataDiagnostico' width="100" [headerText]="'Data Diagnóstico'" [type]="'date'" 
                        [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='dataCura' width="100" [headerText]="'Data Cura'" [type]="'date'" 
                        [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='dataAtendimento' width="100" [headerText]="'Última Modificação'" [type]="'date'" 
                        [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='drt' [headerText]="'DRT'" type="boolean" [displayAsCheckBox]="true"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>






<app-doenca-insercao #doencaInsercao [atendimentoAtualConfiguracao]="atendimentoAtualConfiguracao"></app-doenca-insercao>

<app-doenca-inativacao #doencaInativacao [atendimentoAtualConfiguracao]="atendimentoAtualConfiguracao"></app-doenca-inativacao>

<app-doenca-reativacao #doencaReativacao [atendimentoAtualConfiguracao]="atendimentoAtualConfiguracao"></app-doenca-reativacao>

<app-doenca-atualizacao #doencaAtualizacao [atendimentoAtualConfiguracao]="atendimentoAtualConfiguracao"></app-doenca-atualizacao>


<app-doenca-historico-lista #historico></app-doenca-historico-lista>